import { DEFAULT_USER_SETTINGS, getUserSettings, KEY_USER_SETTINGS, setUserSettings, type UserSettings } from '@/helpers/userSettings'
import { defineStore } from 'pinia';

const supportedDateFormats = [
  'dd.MM.yyyy',
  'yyyy-MM-dd',
  'dd-MM-yyyy',
  'dd-MMM-yyyy',
  'MM/dd/yyyy',
];

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    settings: { ...DEFAULT_USER_SETTINGS }
  }),

  actions: {
    async loadSettings() {
      try {
        // Hier können Sie die Einstellungen vom Backend laden
        // Für jetzt verwenden wir localStorage
        this.settings = getUserSettings();

        if (!supportedDateFormats.includes(this.settings.dateFormat)) {
          this.settings.dateFormat = 'MM/dd/yyyy';
          this.saveSettings(
            this.settings,
          );
        }

      } catch (error) {
        console.error('Fehler beim Laden der Einstellungen:', error)
        throw error
      }
    },

    async saveSettings(newSettings: UserSettings) {
      try {
        // Hier können Sie die Einstellungen ans Backend senden
        // Für jetzt speichern wir in localStorage
        this.settings = { ...newSettings }
        setUserSettings(this.settings);
      } catch (error) {
        console.error('Fehler beim Speichern der Einstellungen:', error)
        throw error
      }
    }
  }
}) 